import http from './http'

const localidadeService = {
  getAll: () => http.get('/localidades').then(result => result.data.data),
  getById: id => http.get(`/localidades/${id}`).then(result => result.data.data),
  getByNome: str => http.get(`/localidades/${str}`).then(result => result.data.data)
}
export default localidadeService
